import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderPlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 16.8v-3.394m0 0v-3.394m0 3.394H8.606m3.394 0h3.394M2.401 17.54V5.258a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954H20.4a1.2 1.2 0 0 1 1.2 1.2v9.33a2.4 2.4 0 0 1-2.4 2.4L4.8 19.94a2.4 2.4 0 0 1-2.4-2.4"
    />
  </svg>
);
export default SvgFolderPlus01;
